export class PaymentResponseModel {
  public offerId: string;
  public orderId: string;
}



// WEBPACK FOOTER //
// ./src/app/models/payment-response.model.ts